import React from 'react';
import { Pane } from 'evergreen-ui';

export default function ChartWrapper({ children }) {
  const wrapper = React.useRef();
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);

  const currentWidth = wrapper.current?.clientWidth;
  const currentHeight = wrapper.current?.clientHeight;

  React.useEffect(() => {
    setWidth(wrapper.current.clientWidth);
    setHeight(wrapper.current.clientHeight);
  }, []);

  React.useEffect(() => {
    const resize = () => {
      const { offsetWidth, offsetHeight } = wrapper.current;
      setWidth(offsetWidth);
      setHeight(offsetHeight);
    };
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  React.useEffect(() => {
    setWidth(currentWidth);
    setHeight(currentHeight);
  }, [currentHeight, currentWidth]);

  return (
    <Pane ref={wrapper} position="relative" display="grid" width="100%">
      {children(width, height)}
    </Pane>
  );
}
